import React, { useContext } from 'react';
import { useAssistantEffect } from '@wix/agent-platform-bm-sdk';

const defaultContextValue = {
  useAssistantEffect,
};

export type AiAssistantContextValue = typeof defaultContextValue;

export const AiAssistantContext = React.createContext(defaultContextValue);

export const AiAssistantContextProvider = AiAssistantContext.Provider;

export const useAiAssistantContext = () => useContext(AiAssistantContext);
